import { motion, AnimatePresence } from 'framer-motion';
import { useWorkFilters } from '../../hooks/useWorkFilters';
import { WorkCard } from './WorkCard';

export function WorkGrid() {
  const { filteredProjects, hasActiveFilters } = useWorkFilters();

  return (
    <section className="py-16 px-8 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        {filteredProjects.length === 0 ? (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center py-24"
          >
            <p className="text-xl text-white/40">
              Keine Projekte gefunden mit diesen Filtern.
            </p>
            <p className="text-sm text-white/30 mt-2">
              Versuche andere Filter oder setze sie zurück.
            </p>
          </motion.div>
        ) : (
          <AnimatePresence mode="wait">
            <motion.div
              key={hasActiveFilters ? 'filtered' : 'all'}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
            >
              {filteredProjects.map((project, index) => (
                <WorkCard key={project.id} project={project} index={index} />
              ))}
            </motion.div>
          </AnimatePresence>
        )}
      </div>
    </section>
  );
}
